import { render, staticRenderFns } from "./ModalEventCalendar.vue?vue&type=template&id=983c1632&"
import script from "./ModalEventCalendar.vue?vue&type=script&lang=js&"
export * from "./ModalEventCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ModalEventCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports